export const INTROS = [
  {
    'pageType': 'reading',
    'title': 'IELTS General Training Reading',
    'time': '1 hour',
    'instructions': [
      'Answer <b>all</b> the questions.',
      'You can change your answers at any time during the test.'
    ],
    'information': [
      'There are 34 questions in this test.',
      'Each question carries one mark.',
      'The test clock will show you when there are 10 minutes and 5 minutes remaining.'
    ],
    'message': "Do not click 'Start test' until you are told to do so.",
    'btnText': 'Start test'
  }
];
